import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { MyContext } from "../../Context/MyProvider";
import profileDefault from "../../Images/profile-default.png";
import Login from "../Login&SignUp/Login";
import Signup from "../Login&SignUp/SignUp";

const getLoginData = () => {
    try {
        return JSON.parse(localStorage.getItem("LoginData") || "null");
    } catch {
        return null;
    }
};

const getProfileImage = (loginData, baseUrl) => {
    const imagePath = loginData?.pro_pic || loginData?.imagePath || loginData?.profile_image || loginData?.image;

    if (!imagePath) {
        return profileDefault;
    }

    if (/^https?:\/\//i.test(imagePath)) {
        return imagePath;
    }

    if (loginData?.imagePath) {
        return `https://yblapis.ganpatigroupbharat.com/${imagePath}`;
    }

    return `${baseUrl}${imagePath}`;
};

const DesktopUserChip = () => {
    const navigate = useNavigate();
    const { BaseUrl, isLoginShow, setIsLoginShow, isSignUpShow, setIsSignUpShow } = useContext(MyContext);
    const loginData = getLoginData();
    const isLoggedIn = Boolean(localStorage.getItem("Userid") && loginData);
    const displayName = loginData?.name || loginData?.username || "User";

    const handleProfileClick = () => {
        if (isLoggedIn) {
            navigate("/profile");
            return;
        }

        setIsLoginShow(true);
    };

    return (
        <>
            <button
                type="button"
                className="desktop_user_chip desktop_user_chip_button"
                onClick={handleProfileClick}
                aria-label={isLoggedIn ? "Open profile" : "Login"}
            >
                <img src={getProfileImage(loginData, BaseUrl)} alt="" />
                <span>Hello, {displayName}</span>
            </button>

            {isLoginShow && (
                <div onClick={() => setIsLoginShow(false)} className="auth_modal_overlay flex bg-[#00000069] h-full justify-center w-full fixed items-center left-0 top-0 z-[999]">
                    <div onClick={(e) => e.stopPropagation()} className="model md:mx-auto mx-2">
                        <Login />
                    </div>
                </div>
            )}

            {isSignUpShow && (
                <div onClick={() => setIsSignUpShow(false)} className="auth_modal_overlay flex bg-[#00000069] h-full justify-center w-full fixed items-center left-0 top-0 z-[999]">
                    <div onClick={(e) => e.stopPropagation()} className="model">
                        <Signup />
                    </div>
                </div>
            )}
        </>
    );
};

export default DesktopUserChip;
